module.exports = __webpack_public_path__ + "img/陆荫英.83e700d6.png";